// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FieldNumberOutlinedSvg from "@ant-design/icons-svg/es/asn/FieldNumberOutlined";
import AntdIcon from '../components/AntdIcon';

var FieldNumberOutlined = function FieldNumberOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FieldNumberOutlinedSvg
  }));
};

FieldNumberOutlined.displayName = 'FieldNumberOutlined';
export default React.forwardRef(FieldNumberOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FieldNumberOutlined.js
// module id = 1079
// module chunks = 0